
const UITemplateTypes = Object.freeze({
	NONE: "None",
	BLANK: "Blank",
	INTRO_SPLASH: "Intro Splash",
	TITLE: "Title",
	CONTENT: "Content",
	BRANCH: "Branch",
	EULA: "EULA",
	TITLE_MENU_6: "Title Menu (6)",
	TITLE_MENU_12: "Title Menu (12)",
	FULL_PAGE_TEXT: "Full Page Text",
	FINISH_PROCEDURE: "Finish Procedure",
	CUSTOM: "Custom",
	QUIZ_RESULTS: "Quiz Results",
});

export function listTemplateTypes()
{
	const templateOptions = new Array<string>();
	for (const key of Object.keys(UITemplateTypes))
	{
		templateOptions.push(UITemplateTypes[key]);
	}

	return templateOptions;
}

export function getTemplateTypes()
{
	const templateOptions = new Array<{ display: string, value: string }>();
	for (const key of Object.keys(UITemplateTypes))
	{
		templateOptions.push({ display: UITemplateTypes[key], value: UITemplateTypes[key] });
	}

	return templateOptions;
}

export default UITemplateTypes;
